import * as React from 'react';

import { IContentfulImageBlock } from '../../../utils/fragments/ImageBlockFragment';
import { useTranslate } from '@sorpetaler/ui/src/utils/translation/useTranslation';
import * as styles from '../DoorWidget.module.less';
import { OptionTileContainer } from '../OptionTileContainer/OptionTileContainer';

interface IDoorDesignProps {
  onSelect: (elements: string[]) => void;
  selectedItems: string[];
  sections: IContentfulImageBlock[];
}

const DoorDesignSection: React.FC<{
  section: IContentfulImageBlock;
  selectedItems: string[];
  handleSelect: (title: string) => void;
}> = ({ section, selectedItems, handleSelect }) => {
  return (
    <OptionTileContainer
      images={section.images || []}
      selectedItems={selectedItems}
      onSelect={handleSelect}
      centered
    />
  );
};

export const DoorDesign: React.FunctionComponent<IDoorDesignProps> = ({
  onSelect,
  selectedItems,
  sections,
}) => {
  const { t } = useTranslate();

  const handleSelect = (title: string) => {
    const isSelected = selectedItems.includes(title);
    if (isSelected) {
      onSelect(selectedItems.filter((item) => item !== title));
    } else {
      onSelect([...selectedItems, title]);
    }
  };

  return (
    <div className={styles.step2Container}>
      <div className={styles.sectionsContainer}>
        {sections.length === 0 && (
          <div className={styles.noItemsFound}>
            {t('noDoorDesignsFound') || 'No door designs found.'}
          </div>
        )}
        {sections.map((section) => (
          <div key={section.slug} className={styles.section}>
            <div className={styles.sectionTitle}>
              <div className={styles.containerWrapper}>
                <div>
                  {section.title.split(/(\*[^*]+\*)/g).map((part, index) => {
                    const isHighlighted =
                      part.startsWith('*') && part.endsWith('*');
                    const text = isHighlighted ? part.slice(1, -1) : part;

                    if (isHighlighted) {
                      return (
                        <span key={index} className={styles.sectionHighlight}>
                          {text}
                        </span>
                      );
                    }

                    return <React.Fragment key={index}>{text}</React.Fragment>;
                  })}
                </div>
              </div>
            </div>
            <DoorDesignSection
              section={section}
              selectedItems={selectedItems}
              handleSelect={handleSelect}
            />
          </div>
        ))}
      </div>
    </div>
  );
};
